module.exports = __webpack_public_path__ + "img/mon_24.ce708de7.png";